import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaskStatus } from 'enums/mowerEnvironment';
import { Task, TaskState } from 'models/mowerEnvironmentModels';

const initialState: TaskState = {
  tasks: [{
    id: 'isAllowed',
    task: 'Check it is allowed in Live',
    status: TaskStatus.NOT_STARTED,
  },
  {
    id: 'ownership',
    task: 'Move to Ownership',
    status: TaskStatus.NOT_STARTED,
  },
  {
    id: 'remoteDebugSession',
    task: 'Remote Debug Session',
    status: TaskStatus.NOT_STARTED,
  },
  {
    id: 'remoteDebugSessionStart',
    task: 'Remote Debug Session Start',
    status: TaskStatus.NOT_STARTED,
  },
  {
    id: 'mowerLogIn',
    task: 'Mower Log In',
    status: TaskStatus.NOT_STARTED,
  },
  {
    id: 'changeMowerHost',
    task: 'Change Host',
    status: TaskStatus.NOT_STARTED,
  },
  {
    id: 'reconnectMower',
    task: 'Reconnect Mower',
    status: TaskStatus.NOT_STARTED,
  }]
};

const mowerEnvironmentSlice = createSlice({
  name: 'mowerEnvironment',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    setTaskStartedById: (state, action: PayloadAction<string>) => {
      state.tasks.forEach((task: Task, i: number) => {
        if (task.id === action.payload) {
          state.tasks[i].status = TaskStatus.STARTED;
          
        }

        return state;
      })
    },
    setTaskSuccessfulById: (state, action: PayloadAction<string>) => {
      state.tasks.forEach((task: Task, i: number) => {
        if (task.id === action.payload) {
          state.tasks[i].status = TaskStatus.SUCCESSFUL;
        }

        return state;
      })
    },
    setTaskErrorById: (state, action: PayloadAction<string>) => {
      state.tasks.forEach((task: Task, i: number) => {
        if (task.id === action.payload) {
          state.tasks[i].status = TaskStatus.ERROR;
        }

        return state;
      })
    },
    resetTaskStatus: (state) => {
      state.tasks = initialState.tasks;
    }

    /* eslint-disable no-param-reassign */
  },
});

export const mowerEnvReducer = mowerEnvironmentSlice.reducer;
export const { setTaskStartedById, setTaskSuccessfulById, setTaskErrorById, resetTaskStatus } = mowerEnvironmentSlice.actions;